
import focusChild from '@/lib/focusChild';
import AppAiIcon from '@/components/core/AppAiIcon';

export default {
  name: 'AppRadioLabel',
  components: {
    AppAiIcon
  },
  props: {
    disabled: { type: Boolean, default: false },
    label: { type: String, default: null },
    checked: { type: Boolean, required: true },
    value: { type: [String, Number, Boolean], default: null },
    tooltip: { type: [String, Object], default: null },
    isBlock: { type: Boolean, default: false },
    leadingAiIconName: {
      type: String,
      default: null,
      validator: v => ['icon-ai-gradation', 'icon-ai-solid'].includes(v)
    },
    inputPosition: { type: String, default: 'right' }
  },
  methods: {
    selectSubItem() {
      if (!this.$el.contains(document.activeElement)) focusChild(this.$el);
    }
  }
};
